import { Page } from "../../Components/Page/Page.component";
import { LocationsTable } from "./Locations.table";

export const LocationsPage = () => {
  return (
    <Page title="Locations">
      <LocationsTable />
    </Page>
  );
};
